/* esm.sh - applesauce-core@5.2.0/event-store */
export * from "/*applesauce-core@5.2.0/esnext/event-store.mjs";
